import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { environment } from '@env/environment';
import { registerLocaleData } from '@angular/common';
import localDe from '@angular/common/locales/de';
import localDeExtra from '@angular/common/locales/extra/de';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client';
import { MatIconRegistry } from '@angular/material/icon';
import { initApp } from './core/bootstrap/initializer';

registerLocaleData(localDe, 'de-DE', localDeExtra);

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideRouter(routes),

    // INFRASTRUCTURE, not a frontend concern: in the np/prod environments
    // ASSET_URL points at an S3 bucket, so de-DE.json/en-EN.json must be
    // fetchable via the browser from every real frontend origin (local dev
    // included). A CORS failure here needs a bucket CORS-policy fix — never
    // a frontend proxy/no-cors workaround or hardcoded translations.
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: `${environment.ASSET_URL}/i18n/`,
        suffix: '.json',
      }),
      fallbackLang: 'de-DE',
      lang: 'de-DE',
    }),

    provideApollo(() => {
      const httpLink = inject(HttpLink);

      return {
        link: httpLink.create({
          uri: environment.HTTP_GRAPHQL_ENDPOINT,
        }),
        cache: new InMemoryCache(),
      };
    }),

    provideAppInitializer(initApp()),

    // Icons ship as Material Symbols Outlined (see src/index.html font link);
    // switch mat-icon's default ligature fontSet to match, app-wide.
    provideAppInitializer(() => {
      inject(MatIconRegistry).setDefaultFontSetClass(
        'material-symbols-outlined',
        'mat-ligature-font',
      );
    }),
  ],
};
